
import Input from 'rc-input';
import PropTypes from "prop-types";
import {useState} from "react";


export function TextInput(props){

    const [textInput, setTextInput] = useState(props.value);

    const handleChange = (event) => {
        setTextInput(event.target.value===null?"":event.target.value);
    }
    const handleFocus = (e) => {
        e.target.select();
    }
    return (
        <Input onFocus={handleFocus}  placeholder={props.placeholder} value={textInput} onChange={handleChange} disabled={props.disable} onBlur={()=>props.setValue(textInput)}/>
    )
}
TextInput.propTypes = {
    setValue: PropTypes.func.isRequired,
    value :PropTypes.string.isRequired,
    disable: PropTypes.bool.isRequired,
    placeholder: PropTypes.string.isRequired,

}
TextInput.defaultProps = {
    placeholder: "Enter Text"
}